import React from 'react';

export const ForgePioGithubSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
				fill="#24292E"
			/>
			<path d="M8 11h16v10H8V11z" fill="white" />
			<path
				d="M11 13h10v1.33H11V13zm0 2.67h10v1.33H11v-1.33zm0 2.66h8v1.34H11v-1.34z"
				fill="#24292E"
			/>
		</svg>
	);
};
